import React,{useState , useEffect} from "react";
import { Link } from "react-router-dom";
import {APP_URL,API_ENDPOINT,FOOTER_SITE , BACKEND_URL} from '../components/config/Common'
import {Links} from '../routes/PathLink'

import { LazyLoadImage,LazyLoadComponent } from 'react-lazy-load-image-component';
//import { FloatingWhatsApp } from 'react-floating-whatsapp'
import { useSiteSettings } from '../site-settings/site-settings';
import { AiFillTwitterCircle, AiFillInstagram, AiFillFacebook, AiFillLinkedin , AiFillYoutube } from 'react-icons/ai';
import { nanoid } from 'nanoid';


const Footer = ({ishome,hidegroup,hidefooter}) => {
    const [access_token,setAccess_token] = useState(localStorage.getItem('access_token'));
    const [isLogin, setIsLogin] = useState(false)
    const [footergroup , setFootergroup] = useState([]);
    const [column1data , setColumn1data] = useState([]);
    const [column2data , setColumn2data] = useState([]);
    const [column3data , setColumn3data] = useState([]);
    const [column3indicedata , setColumnindicedata] = useState([]);
    const [columnnewsecdata , setColumnnewsecdata] = useState([]);
    const [footerbottomdata , setFooterbottomdata] = useState([]);
    
    const [paymenticons , setPaymenticons] = useState([]);
    const [followicons , setFollowicons] = useState([]);
    const [loadFooter , setSetLoadFooter] = useState(false);
   const { sitelogo } = useSiteSettings();
    useEffect(() => {
      
        get_footer_footergroupsec();
        get_footer_column1();
        get_footer_column2();
        get_footer_column3();
        get_footer_indices();
        get_footer_newsector();
        get_footer_footerbottom();
        //getPaymentIcon();
        getfollowLinks();

        setTimeout(() => {
            setSetLoadFooter(true);
         }, 1000)
   },[])

    useEffect(() => {
        if(access_token){
            setIsLogin(true)
        }
    }, [access_token]);

    const getPaymentIcon=()=>{
       /* fetch(`${APP_URL}/img/paymenticons/paymenticons.json`
        ,{
          headers : { 
            'Content-Type': 'application/json',
            'Accept': 'application/json'
           }
        }
        )
          .then(function(response){
            
            return response.json();
          })
          .then(function(myJson) {
            setPaymenticons(myJson)
          });
          */
      }

    const getfollowLinks=()=>{
       /* fetch(`${APP_URL}/sociallinkFooterjson.json`
        ,{
          headers : { 
            'Content-Type': 'application/json',
            'Accept': 'application/json'
           }
        }
        )
          .then(function(response){
            
            return response.json();
          })
          .then(function(myJson) {
            setFollowicons(myJson)
          });
          */
      }

     const get_footer_footergroupsec = () =>{

        /* fetch(`${API_ENDPOINT}/get_categorylevel_list`,{
            method: 'GET',
            headers : {        
                'Content-Type': 'application/json',
                'Accept': 'application/json', 
            }
        }).then(function (response) {
                return response.json();
        }).then( (result)=> {
            
            if(result.status === 1){
               setFootergroup(result?.data);
            }
        })
            */

    }

    const get_footer_column1 = () =>{

        fetch(`${API_ENDPOINT}/get_footer_links?colum=column1`,{
            method: 'GET',
            headers : {        
                'Content-Type': 'application/json',
                'Accept': 'application/json', 
            }
        }).then(function (response) {
                return response.json();
        }).then( (result)=> {
           
            if(result.status === 1){
               setColumn1data(result?.data);
            }
        })
    }

    const get_footer_column2 = () =>{

        fetch(`${API_ENDPOINT}/get_footer_links?colum=column2`,{
            method: 'GET',
            headers : {        
                'Content-Type': 'application/json',
                'Accept': 'application/json', 
            }
        }).then(function (response) {
                return response.json();
        }).then( (result)=> {
            if(result.status === 1){
               setColumn2data(result?.data);
            }
        })
    }

const get_footer_column3 = () =>{

        fetch(`${API_ENDPOINT}/get_footer_links?colum=column3`,{
            method: 'GET',
            headers : {        
                'Content-Type': 'application/json',
                'Accept': 'application/json', 
            }
        }).then(function (response) {
                return response.json();
        }).then( (result)=> {
            if(result.status === 1){
               setColumn3data(result?.data);
            }
        })
    }
    
   const get_footer_indices = () =>{

        fetch(`${API_ENDPOINT}/get_footer_links?colum=columnindices`,{
            method: 'GET',
            headers : {        
                'Content-Type': 'application/json',
                'Accept': 'application/json', 
            }
        }).then(function (response) {
                return response.json();
        }).then( (result)=> {
            if(result.status === 1){
            
               setColumnindicedata(result?.data);
            }
        })
    }
    
    const get_footer_newsector = () =>{

        fetch(`${API_ENDPOINT}/get_footer_links?colum=newssector`,{
            method: 'GET',
            headers : {        
                'Content-Type': 'application/json',
                'Accept': 'application/json', 
            }
        }).then(function (response) {
                return response.json();
        }).then( (result)=> {
            if(result.status === 1){

               setColumnnewsecdata(result?.data);
            }
        })
    }
    
    
    
    
    
    const get_footer_footerbottom = () =>{

        fetch(`${API_ENDPOINT}/get_footer_links?colum=footerbottom`,{
            method: 'GET',
            headers : {        
                'Content-Type': 'application/json',
                'Accept': 'application/json', 
            }
        }).then(function (response) {
                return response.json();
        }).then( (result)=> {
            if(result.status === 1){
               setFooterbottomdata(result?.data);
            }
        })
    }


    if(loadFooter){
    return (        
        <>
            {/*<FloatingWhatsApp
                        phoneNumber="+91 8208636201"
                        accountName="JOCOJO Tshirts"
                        allowEsc
                        allowClickAway
                        notification
                        notificationSound
                        avatar={`${process.env.REACT_APP_URL+'/img/jocojo_logo_60.webp'}`}
                      />*/}
            <div className="flex w-full h-6 "></div>
            {/* Top */}
            {hidefooter ?
                null
                :
            <>
            
             <div className="px-4 pt-2 text-sm bg-white block md:hidden ">
                <p className="text-sm">Disclaimer: The information provided on this website is for educational and informational purposes only and should not be construed as investment advice, financial advice, trading advice, or any other form of recommendation.Investments in securities market are subject to market risks. Please read all related documents carefully before investing.</p>
            </div>
            
            <div className="flex block bg-white ">
            <div className="grid w-full grid-cols-2 md:grid-cols-[repeat(auto-fill,minmax(260px,1fr))] gap-6 pt-4 pb-16 md:grid-cols-3 xl:grid-cols-[repeat(auto-fit,minmax(220px,1fr))] xl:gap-8 2xl:gap-2 2xl:grid-cols-4 px-5 md:px-10 lg:px-[50px] xl:px-16 justify-center m-auto">
                {/*<div className="flex flex-col hidden md:block">
                    <h3 className="mt-3 mb-7 text-lg  dark:text-zinc-300">
                    USEFUL LINKS
                    </h3>
                    <ul className="space-y-2">
                        {column1data.map((val,key) => (
                        <li key={`ulink-${nanoid()}`}>
                            {val.link_type == 'relative'?
                                <>{val?.logged_in_only == 1 ?
                                   <>{isLogin && <Link to={`${APP_URL}/${val.url}`} replace={true} className="text-sm text-heading transition-colors hover:text-accent-hover dark:text-zinc-300 dark:hover:text-orange-500"   >{val.title}</Link>}</>
                                    :
                                    <Link to={`${APP_URL}/${val.url}`} replace={true} className="text-sm text-heading transition-colors hover:text-accent-hover dark:text-zinc-300 dark:hover:text-orange-500"   >{val.title}</Link>
                                  }
                                </>
                               :
                               <Link to={`${val.url}`}  replace={true} className="text-sm text-heading transition-colors hover:text-accent-hover dark:text-zinc-300 dark:hover:text-orange-500" target="_blank"  >{val.title}</Link>
                              } 
                        </li>
                     ))
                    }
                    </ul>
                </div>*/}

                <div className="flex flex-col">
                <h3 className="mt-3 mb-7 text-lg  dark:text-zinc-300">
                    GET TO KNOW US
                    </h3>
                    <ul className="space-y-2">
                   
                     {column2data.map((val,key) => (
                        <li key={nanoid()}>
                            {val.link_type == 'relative'?
                                <Link to={`${APP_URL}/${val.url}`} replace={true} className="text-sm text-heading transition-colors hover:text-accent-hover dark:text-zinc-300 dark:hover:text-orange-500"   >{val.title}</Link>
                               :
                               <Link to={`${val.url}`}  replace={true} className="text-sm text-heading transition-colors hover:text-accent-hover dark:text-zinc-300 dark:hover:text-orange-500"  target="_blank"    >{val.title}</Link>
                              } 
                        </li>
                     ))
                    }
                    </ul>
                    
                    <h3 className="mt-8 mb-3 text-xl  text-heading dark:text-zinc-300">
                    Follow us on
                    </h3>
                    <div className="flex">
                        <a href="https://www.facebook.com/BULLSCREEN/" rel="noreferrer" target="_blank" className="mr-2 text-3xl text-accent hover:text-[#1877f2]"><AiFillFacebook /></a>
                        <a href="https://x.com/bullscreenalpha" rel="noreferrer" target="_blank" className="mr-2 text-3xl text-accent hover:text-[#1da1f2]"><AiFillTwitterCircle /></a>
                        <a href="https://www.instagram.com/bullscreenalpha" rel="noreferrer" target="_blank" className="mr-2 text-3xl text-accent hover:text-[#c13584]"><AiFillInstagram /></a>
                        <a href="https://www.linkedin.com/company/bullscreen/" rel="noreferrer" target="_blank" className="mr-2 text-3xl text-accent hover:text-[#0A66C2]"><AiFillLinkedin /></a>
                        <a href="https://www.youtube.com/@BULLSCREEN" rel="noreferrer" target="_blank" className="mr-2 text-3xl text-accent hover:text-[#0A66C2]"><AiFillYoutube /></a>
                    </div>
                    
                      <div className="my-6">
                      	    <h3 className="mt-2 mb-3 text-xl  text-heading dark:text-zinc-300">
                    Download BullScreen App
                    </h3>
                    	<div className="flex w-48 ">
                          <a href="https://play.google.com/store/apps/details?id=com.bullscreenapp" rel="noreferrer" target="_blank" className="mr-2 text-2xl  hover:text-[#0A66C2]">
                          <img alt="Download App from play store" 
                           loading="lazy" 
                           decoding="async" 
                           data-nimg="1" 
                           class="w-full h-full object-contain" src={`${BACKEND_URL}/img/play-store-download_google.png?v=3`} 
                        /></a>
                        </div>
                    </div>
                </div>
                
                 <div className="flex flex-col">
                     <h3 className="mt-3 mb-7 text-lg dark:text-zinc-300">
                     MARKET
                    </h3>
                    	<ul className="space-y-2">
                    {column3indicedata.map((val,key) => (
                        <li key={nanoid()}>
                            {val.link_type == 'relative'?
                                <Link to={`${APP_URL}/${val.url}`} replace={true} className="text-sm text-heading transition-colors hover:text-accent-hover dark:text-zinc-300 dark:hover:text-orange-500"   >{val.title}</Link>
                               :
                               <Link to={`${val.url}`}  replace={true} className="text-sm text-heading transition-colors hover:text-accent-hover dark:text-zinc-300 dark:hover:text-orange-500"   >{val.title}</Link>
                              } 
                        </li>
                     ))
                    }
                    </ul>
                
          
            	</div>
                <div className="flex flex-col">
                <h3 className="mt-3 mb-7 text-lg dark:text-zinc-300">
                    EXPLORE
                    </h3>
                    <ul className="space-y-2">
                      
                    {column3data.map((val,key) => (
                        <li key={nanoid()}>
                            {val.link_type == 'relative'?
                                <Link to={`${APP_URL}/${val.url}`} replace={true} className="text-sm text-heading transition-colors hover:text-accent-hover dark:text-zinc-300 dark:hover:text-orange-500"   >{val.title}</Link>
                               :
                               <Link to={`${val.url}`}  replace={true} className="text-sm text-heading transition-colors hover:text-accent-hover dark:text-zinc-300 dark:hover:text-orange-500"  target="_blank"   >{val.title}</Link>
                              } 
                        </li>
                     ))
                    }
                    </ul>
                </div>
                 <div className="flex flex-col">
                     <h3 className="mt-3 mb-7 text-lg dark:text-zinc-300">
                     NEWS
                    </h3>
                    <ul className="space-y-2">
                    {columnnewsecdata.map((val,key) => (
                        <li key={nanoid()}>
                            {val.link_type == 'relative'?
                                <Link to={`${APP_URL}/${val.url}`} replace={true} className="text-sm text-heading transition-colors hover:text-accent-hover dark:text-zinc-300 dark:hover:text-orange-500"   >{val.title}</Link>
                               :
                               <Link to={`${val.url}`}  replace={true} className="text-sm text-heading transition-colors hover:text-accent-hover dark:text-zinc-300 dark:hover:text-orange-500"  target="_blank"  >{val.title}</Link>
                              } 
                        </li>
                     ))
                    }
                    </ul>
                   
            	</div>
               
            	</div>
            </div>
            </>
            }
            <div className="px-4 pb-2 text-sm bg-white hidden md:block">
                <p>Disclaimer: The information provided on this website is for educational and informational purposes only and should not be construed as investment advice, financial advice, trading advice, or any other form of recommendation.Investments in securities market are subject to market risks. Please read all related documents carefully before investing.</p>
               
            </div>
            <div className=" gap-y-4 mt-0 mt-0 lg:mb-0 flex w-full flex-col  items-center border-t border-gray-200 pt-8 pb-3 lg:mt-0 lg:flex-row lg:justify-between lg:border-t-0 px-5 md:px-10 lg:px-[50px] xl:px-16" style={{backgroundColor:'#18cb96'}}>
                <span className="order-2 text-sm text-white lg:order-1 dark:text-zinc-300">
                <div className="flex flex-col gap-y-4 md:gap-y-0 md:flex-row">
                <div >
                &copy; Copyright {new Date().getFullYear()}{' '}
                
                  {FOOTER_SITE} &nbsp;
                
                All rights reserved. 
                </div>
            	<div className="ml-0 md:ml-4 flex gap-x-6">
<ul class="flex flex-wrap gap-x-4 gap-y-1 justify-start">
                      
                    {footerbottomdata.map((val,key) => (
                        <li key={nanoid()}>
                            {val.link_type == 'relative'?
                                <Link to={`${APP_URL}/${val.url}`} replace={true} className="text-sm text-white transition-colors hover:text-gray-500 dark:text-zinc-300 dark:hover:text-orange-500"   >{val.title}</Link>
                               :
                               <Link to={`${val.url}`}  replace={true} className="text-sm text-white transition-colors hover:text-gray-500 dark:text-zinc-300 dark:hover:text-orange-500" target="_blank"   >{val.title}</Link>
                              } 
                        </li>
                     ))
                    }
                    </ul>
                    </div>
		 </div>
                <div className="mt-2">Powered by {ishome && ishome== 'yes' ? <Link
                    className="font-normal  transition-colors hover:text-accent dark:text-zinc-100 dark:hover:text-accent"
                    to='https://sisnolabs.com/'
                    target="_blank"
                     style={{color:'#a0892d'}}
                >
                  SISNOLABS
                </Link>
                :
                <span className="font-normal">SISNOLABS</span> 
                }
                 </div>
                </span>
            </div>    
        
    
        </>
    )
    }else{
        return null
    }

}

export default Footer;
